<template>
  <div>
    <!-- subject_groups -->
    <a v-b-modal.my-subjects-modal>{{ $t('registration.already-registered-subjects') }}</a>

    <b-modal
      @shown="onShown()"
      :hide-header="true"
      :hide-footer="true"
      content-class="modal-blue"
      id="my-subjects-modal"
      size="xl"
      centered>
        <!-- Modal content-->
        <div class="row ">
          <div class="col mb-5 pb-5 ">
            <h4 class="mb-5">{{ $t('registration.my-subjects') }}</h4>
            <div class="registration-group-table">
              <sk-list v-if="loading" height="0.02" :items-count="4"></sk-list>
              <table v-else class="table table-responsive-lg">
                <thead>
                  <tr>
                    <th>{{ $t('registration.group') }}</th>
                    <th>{{ $t('registration.ects') }}</th>
                    <th>{{ $t('registration.subject') }}</th>
                    <th>{{ $t('registration.lecturer') }}</th>
                    <th>{{ $t('registration.type') }}</th>
                    <th>{{ $t('registration.day') }}</th>
                    <th class="min-width: 100px;">{{ $t('registration.date') }}</th>
                    <th style="min-width: 100px">{{ $t('registration.time') }}</th>
                    <th>{{ $t('registration.room') }}</th>
                    <th style="width: 36px">&nbsp;</th>
                    <th style="width: 36px">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr :class="{ 'border-bottom': !sameAsNextGroup(i) }" v-for="(group, i) of alreadyRegistered">
                    <td>{{ group.group }}</td>
                    <td>{{ group.ECTS }}</td>
                    <td>{{ helpers.getLocalizedField(group, 'subject') }}</td>
                    <td>{{ helpers.getLocalizedField(group, 'lectors') }}</td>
                    <td>{{ helpers.getLocalizedField(group, 'type') }}</td>
                    <td>{{ helpers.getLocalizedField(group, 'day') }}</td>
                    <td>
                      <span v-if="group.start_date && group.start_date !== ''">{{ group.start_date }} <br /> {{ group.end_date }}</span>
                      <span v-else>{{ group.holddate }}</span>
                    </td>
                    <td>{{ group.time + ' - ' + group.time_end }}</td>
                    <td v-if="group.start_date && group.start_date !== ''">
                      {{ $t('registration.curation') }}, {{ helpers.getLocalizedField(group, 'Rooms') }}
                    </td>
                    <td v-else-if="group.Rooms">{{ helpers.getLocalizedField(group, 'Rooms') }}</td>
                    <td v-else>{{ $t('registration.distance-room') }}</td>
                    <td v-if="group.can_not_delete!=1" style="min-width:4rem;">
                      <img class="img-fluid"
                          @click="changeGroup(group)"
                          src="/static/images/icons/registrations/change.png">
                    </td>
                    <td v-if="group.can_not_delete!=1" style="min-width:4rem;">
                      <img class="img-fluid"
                          @click="removeGroup(group)"
                          src="/static/images/icons/registrations/close.png">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="px-5 px-sm-0 mx-5 mx-sm-0">
              <sk-list v-if="loading" height="0.01" :items-count="1"></sk-list>
              <p v-else class="warninng">{{ $t('registration.total-ects') }}: {{ ectsCurrentSemester }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col mt-0 pt-3 mt-sm-5 pt-sm-5 mb-3">
            <button type="button" class="btn btn-light-bold" @click="hideModal()">{{ $t('registration.close') }}</button>
          </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SkList from '../skeletons/sk-list';

  export default {
    name: 'my-subjects-modal',
    components: { SkList },
    computed: {
      totalEcts() {
        return this.alreadyRegistered.reduce(function(a, b){
          return a + parseInt(b.ECTS);
        }, 0);
      },
      ...mapGetters({
        alreadyRegistered: 'registration/alreadyRegistered',
        ectsCurrentSemester: 'registration/ectsCurrentSemester',
      })
    },

    data() {
      return {
        loading: true
      }
    },

    methods: {
      changeGroup(group) {
        
          console.log(group)

        this.$emit('subject-change', group);
         this.$store.dispatch('registration/setsubjectChangeButtonAppear',false)
      },

      frGroup(group) {
        this.$emit('subject-change', group);
        this.$store.dispatch('registration/setsubjectChangeButtonAppear',false)
      },

      removeGroup(group) {
 

        this.$store.dispatch('registration/removeSubject', group.subjectID)
        .then((response) => {
          this.helpers.notifySuccessMessage(this.$t('registration.messages.successfully_removed'));
          this.onShown();
          this.$emit('subject-remove');
        })
      },

      hideModal() {
        this.$bvModal.hide('my-subjects-modal');
      },

      sameAsNextGroup(index) {
        return !this.alreadyRegistered[index + 1] || this.alreadyRegistered[index].subject === this.alreadyRegistered[index + 1].subject;
      },

      onShown() {
        this.$store.dispatch('registration/loadAlreadyRegistered')
        .then(() => {
          this.loading = false
        });
      }
    }
  };
</script>

<style scoped>
  .registration-group-table img {
      cursor: pointer;
  }

</style>
